import styled, { css } from "styled-components";

export const StepperContainer = styled.div`
  display: flex;
  gap: 32px;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const Step = styled.div<{ isActive: boolean }>`
  align-items: center;
  background: ${({ theme, isActive }) =>
    isActive ? theme.colors.blue : theme.colors.grey200};
  border-radius: 50%;
  display: flex;
  font-family: Aileron;
  font-weight: 700;
  font-size: 16px;
  padding: 6px 9px;
  color: ${({ theme }) => theme.colors.white};
`;

export const LabelContainer = styled.div<{ isActive: boolean }>`
  ${({ isActive }) =>
    !isActive &&
    css`
      @media (max-width: 968px) {
        display: none;
      }
    `}
`;
